import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Quote } from 'lucide-react';
import { getImageAssetPath } from '@/lib/imageHelper';

const FoundersSection = () => {
  const ddiImagePath = getImageAssetPath('ddi.jpeg');
  const sbrImagePath = getImageAssetPath('sbr.jpeg');

  const founderQuotes = [
    {
      name: "Dennis Dittrich",
      role: "Co-Founder & Lead Developer",
      image: ddiImagePath,
      quote: "Mobile Apps sind für mich mehr als nur Code - sie sind die Brücke zwischen Unternehmen und ihren Kunden. Jede App, die wir entwickeln, soll echten Mehrwert schaffen.",
      focus: "E-Commerce & User Experience"
    },
    {
      name: "Simon Brüggemann", 
      role: "Co-Founder & Technical Lead",
      image: sbrImagePath,
      quote: "Was mich an der App-Entwicklung fasziniert, ist die Möglichkeit, komplexe Geschäftsprozesse in einfache, intuitive Erlebnisse zu verwandeln. Das ist echte digitale Transformation.",
      focus: "System Architecture & Innovation"
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Was unsere <span className="text-blue-600">Gründer</span> antreibt
          </h2>
          <p className="text-lg text-gray-600">
            Dennis und Simon über ihre Leidenschaft für Mobile App Entwicklung 
            und was sie bei jedem Projekt motiviert.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {founderQuotes.map((founder, index) => (
            <Card key={index} className="border-0 shadow-xl bg-white overflow-hidden">
              <CardContent className="p-8">
                <div className="flex items-start mb-6">
                  <div className="w-20 h-20 rounded-full overflow-hidden bg-gray-200 mr-6 flex-shrink-0">
                    <img 
                      src={founder.image} 
                      alt={founder.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-1">{founder.name}</h3>
                    <p className="text-blue-600 font-semibold text-sm mb-2">{founder.role}</p>
                    <p className="text-gray-600 text-sm">{founder.focus}</p>
                  </div>
                </div>
                
                <div className="relative">
                  <Quote className="h-8 w-8 text-blue-200 absolute -top-2 -left-2" />
                  <blockquote className="text-gray-700 leading-relaxed italic pl-6">
                    "{founder.quote}"
                  </blockquote>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Team Philosophy */}
        <div className="bg-white rounded-xl shadow-xl p-8 max-w-4xl mx-auto mt-16 text-center">
          <h3 className="text-2xl font-bold mb-4 text-gray-900">
            Unser Ansatz
          </h3>
          <p className="text-lg text-gray-600 mb-8">
            Wir entwickeln Apps nicht nur, weil wir es können - sondern weil wir daran glauben, 
            dass mobile Technologie Unternehmen und Menschen helfen kann, erfolgreicher zu sein.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-blue-50 rounded-lg p-6">
              <h4 className="font-bold text-blue-800 mb-2">🎯 Ehrlich beraten</h4>
              <p className="text-blue-700 text-sm">
                Wir sagen dir ehrlich, ob eine App für dich Sinn macht
              </p>
            </div>
            <div className="bg-blue-50 rounded-lg p-6">
              <h4 className="font-bold text-blue-800 mb-2">🛠️ Solide entwickeln</h4>
              <p className="text-blue-700 text-sm">
                Keine Experimente - bewährte Technologien und Methoden
              </p>
            </div>
            <div className="bg-blue-50 rounded-lg p-6">
              <h4 className="font-bold text-blue-800 mb-2">🤝 Langfristig denken</h4>
              <p className="text-blue-700 text-sm">
                Deine App soll auch in Jahren noch funktionieren und wachsen
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FoundersSection; 